import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import { Box, Divider, Typography } from "@mui/material";
import { useNavigate, useParams } from "@tanstack/react-router";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { WaitIcon } from "../../../../components/icons/wait";

function StepsList({
  activityName,
  startTime,
  status,
  responsavel,
  id,
  taskId,
  activityType,
  isSignatureTask,
}: ProcessStepsType): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { requestId } = useParams({
    from: "/__auth/request-history/$requestId",
  });

  const statusMap: Record<string, { text: string; icon: JSX.Element }> = {
    startEvent: {
      text: t("requestHistory.processStarted"),
      icon: <CheckCircleOutlineOutlinedIcon sx={{ color: "green" }} />,
    },
    noneEndEvent: {
      text: "",
      icon: <CheckCircleOutlineOutlinedIcon sx={{ color: "green" }} />,
    },
    ACTIVE: {
      text: t("requestHistory.inProgress"),
      icon: <PlayCircleOutlinedIcon sx={{ color: "#737373" }} />,
    },
    COMPLETED: {
      text: t("requestHistory.completed"),
      icon: <CheckCircleOutlineOutlinedIcon sx={{ color: "green" }} />,
    },
    NOT_EXECUTABLE: {
      text: t("requestHistory.inProgress"),
      icon: <WaitIcon sx={{ color: "#cfcfcf", fontSize: "1.8rem" }} />,
    },
  };

  const setStatus = (): JSX.Element | null => {
    let statusKey: string | undefined;

    if (activityType === "userTask" && status === "ACTIVE") {
      statusKey = "ACTIVE";
    } else if (activityType === "startEvent") {
      statusKey = "startEvent";
    } else if (activityType === "noneEndEvent") {
      statusKey = "noneEndEvent";
    } else {
      statusKey = status;
    }

    const currentStatus = statusMap[statusKey];

    return (
      <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {currentStatus.text ? (
          <Typography
            color="white.light"
            fontSize={12}
            fontWeight={400}
            variant="body2"
          >
            {currentStatus.text}
          </Typography>
        ) : null}
        {currentStatus.icon}
      </Box>
    );
  };

  return (
    <Box
      key={id}
      onClick={() => {
        if (status !== "ACTIVE" || !taskId) return;
        void navigate({
          to: `/${isSignatureTask ? "signature" : "task"}/${requestId}/${taskId}` as any,
        });
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: status === "ACTIVE" ? "pointer" : "default",
        padding: 0,
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "12px",
          marginBottom: "4px",
        }}
      >
        <Typography fontSize={14} fontWeight={500} variant="subtitle2">
          {activityName}
        </Typography>
        {setStatus()}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontSize={12} fontWeight={400} variant="body2">
          {format(new Date(startTime), "dd/MM/yyyy")}
        </Typography>
        <Typography
          color="white.light"
          fontSize={12}
          fontWeight={400}
          variant="body2"
        >
          {responsavel}
        </Typography>
      </Box>
      <Divider />
    </Box>
  );
}

export default StepsList;
